import { Component, Inject, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Api } from '../../services/api';
import { AlertService } from '../../services/alert.service';

@Component({
  selector: 'app-mdl-modify-p-item',
  imports: [CommonModule, FormsModule],
  templateUrl: './mdl-modify-p-item.html',
  styleUrl: './mdl-modify-p-item.css'
})
export class MdlModifyPItem {
  items: any[] = [];
  presupuestoId: string = '';
  
  private api = inject(Api);
  private alertService = inject(AlertService);
  
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public mdl: MatDialogRef<MdlModifyPItem>
  ) {
    console.log('Datos recibidos en mdl-modify-p-item:', data);
    this.presupuestoId = data.presupuestoId;
    this.items = data.items || [];
   }

  closeMdl() {
    this.mdl.close();
  }

  calculateTotal(index: number) {
    const item = this.items[index];
    if (item.cantidad && item.precio_unitario) {
      item.total = item.cantidad * item.precio_unitario;
    }
  }

  formatNumber(value: number): string {
    if (!value) return '';
    return value.toLocaleString('es-ES');
  }

  parseNumber(value: string): number {
    if (!value) return 0;
    return parseFloat(value.replace(/\./g, '').replace(',', '.')) || 0;
  }

  updateCantidad(index: number, event: any) {
    const value = event.target.value;
    this.items[index].cantidad = this.parseNumber(value);
    event.target.value = this.formatNumber(this.items[index].cantidad);
  }

  updatePrecio(index: number, event: any) {
    const value = event.target.value;
    this.items[index].precio_unitario = this.parseNumber(value);
    event.target.value = this.formatNumber(this.items[index].precio_unitario);
  }

  saveChanges() {
    this.api.showLoading();
    
    const payload = {
      presupuesto_id: this.presupuestoId,
      items: this.items.map(item => ({
        presupuesto_item_id: item.presupuesto_item_id,
        cantidad: item.cantidad,
        precio_unitario: item.precio_unitario,
        total: item.cantidad * item.precio_unitario
      }))
    };

    this.api.updateBudget(payload).subscribe({
      next: (res: any) => {
        this.api.hideLoading();
        this.alertService.success('Éxito', 'Items modificados exitosamente');
        this.mdl.close(true);
      },
      error: (err: any) => {
        this.api.hideLoading();
        this.alertService.error('Error', 'Error al modificar los items');
        console.error('Error:', err);
      }
    });
  }
}
